export default __webpack_public_path__ + "static/planet-green-left-6b44c342240f371a0c9de1f935d47fdf.png";